import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { AccountingModelModel } from 'src/app/models/management/accounting-model.model';
import { environment } from './../../../environments/environment';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';

@Injectable({
  providedIn: 'root'
})
export class AccountingModelService {

  private readonly _httpClient = inject(HttpClient);

  createAccountingModel(accountingModelContract: AccountingModelModel): Observable<AccountingModelModel> {
    return this._httpClient.post<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.CreateAccountingModel}`,
      accountingModelContract
    );
  }

  deleteAccountingModel(accountingModelId: number): Observable<AccountingModelModel> {
    return this._httpClient.delete<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.DeleteAccountingModel}/${accountingModelId}`
    );
  }

  getAccountingModelByConsecutive(consecutive: number): Observable<AccountingModelModel> {
    return this._httpClient.get<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.GetAccountingModelByConsecutive}/${consecutive}`
    );
  }

  getAccountingModelById(accountingModelId: number): Observable<AccountingModelModel> {
    return this._httpClient.get<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.GetAccountingModelById}/${accountingModelId}`
    );
  }

  getAllAccountingModelsForSelectAsync(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.GetAllAccountingModelsForSelectAsync}`
    );
  }

  getFirstAccountingModelByKeysAsync(): Observable<AccountingModelModel> {
    return this._httpClient.get<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.GetFirstAccountingModelByKeysAsync}`
    );
  }

  getLastAccountingModelByKeysAsync(): Observable<AccountingModelModel> {
    return this._httpClient.get<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.GetLastAccountingModelByKeysAsync}`
    );
  }

  getNextAccountingModelByKeysAsync(consecutive: number): Observable<AccountingModelModel> {
    const itemFilterResponse = new ItemFilterModel('consecutive', consecutive, null, '');
    return this._httpClient.post<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.GetNextAccountingModelByKeysAsync}`,
      itemFilterResponse
    );
  }

  getPreviusAccountingModelByKeysAsync(consecutive: number): Observable<AccountingModelModel> {
    const itemFilterResponse = new ItemFilterModel('consecutive', consecutive, null, '');
    return this._httpClient.post<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.GetPreviusAccountingModelByKeysAsync}`,
      itemFilterResponse
    );
  }

  updateAccountingModel(accountingModelContract: AccountingModelModel): Observable<AccountingModelModel> {
    return this._httpClient.put<AccountingModelModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.accountingModel.UpdateAccountingModel}`,
      accountingModelContract
    );
  }

}
